import React, { useState } from "react";
import { useMatch } from "react-router";

interface Props {
  kindlyKey: string;
  activePathList: string[];
}
// https://docs.kindly.ai/api/chat#II4st
interface KindlyOptions {
  bubbleAvatar?: string;
  bubbleHidden?: boolean;
  chatbubble?: {
    autopopup?: boolean;
    autopopup_time?: number;
  };
  context?: object;
  customFont?: string;
  fullscreenMode?: boolean;
  hideHeader?: boolean;
  language?: string;
  position?: {
    bottom?: string;
    right?: string;
  };
  shadowDom?: boolean;
  styles?: string;
  zIndex?: number;
}
// https://docs.kindly.ai/api/chat#FvnGS
interface KindlyChat {
  isBrowserCompatible: boolean;
  showBubble: () => void;
  hideBubble: () => void;
  openChat: () => void;
  closeChat: () => void;
  restartChat: (options: { openChat: boolean }) => void;
  sendMessage: (
    message: string,
    options: {
      sender: "user";
      newContext?: Record<string, string>;
      openChat?: boolean;
    },
  ) => void;
  triggerDialogue: (dialogueId: string, options?: { languageCode?: string; openChat?: boolean }) => void;
  identifyUser: (user: {
    full_name: string;
    user_id?: string;
    avatar_url?: string;
    email?: string;
    phone_number?: string;
  }) => void;
  setNewContext: (context: Record<string, string>) => void;
  setNewLabel: (label: string) => void;
  APIRoot: HTMLElement;
}
declare global {
  interface Window {
    kindlyOptions?: KindlyOptions;
    kindlyChat?: KindlyChat;
  }
}

const KindlyChat: React.FC<Props> = (props) => {
  const isActivePath =
    props.activePathList.filter((path) => {
      return useMatch(path);
    })?.length > 0;
  const [isInjected, setIsInjected] = useState(false);

  React.useEffect(() => {
    if (!isInjected && isActivePath) {
      window.kindlyOptions = {
        bubbleHidden: false,
        hideHeader: false,
        fullscreenMode: false,
      };

      const script = document.createElement("script");
      script.id = "kindly-chat";
      script.src = "https://chat.kindlycdn.com/kindly-chat.js";
      script.async = true;
      script.setAttribute("data-bot-key", props.kindlyKey);
      document.body.appendChild(script);
      setIsInjected(true);
    }
  }, [isActivePath, isInjected, props.kindlyKey]);

  return null;
};

export default KindlyChat;
